import { render, staticRenderFns } from "./editPix.vue?vue&type=template&id=1db4f98b&scoped=true"
import script from "./editPix.vue?vue&type=script&lang=ts"
export * from "./editPix.vue?vue&type=script&lang=ts"
import style0 from "./editPix.vue?vue&type=style&index=0&id=1db4f98b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1db4f98b",
  null
  
)

export default component.exports